export const environment = {
  production: true,
  version: 'e1276189eb'
};
